module.exports = __webpack_public_path__ + "static/media/skywind.64e4ba8f.png";